/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import './ArticleInfo.scss';
import Button from '../Button/Button';
import { changeArticleState } from '../../../requests/requests';

export default function ArticleInfo({
  id, title, description, status, author,
}) {
  useEffect(() => {}, []);

  const handle_click = (_id) => {
    changeArticleState(_id);
  };

  return (
    <section className="ArticleInfo">
      <p className="article-info__item">{id}</p>
      <p className="article-info__item">{title}</p>
      <p className="article-info__item">{description}</p>
      <div className="article-info__item">
        <p>
          {status}
        </p>
        <Button
          name={status === 'unpublished' ? 'publish' : 'unpublish'}
          handle_click={() => handle_click(id)}
          className="admin_button_secondary"
        />
      </div>
      <p className="article-info__item">{author}</p>
    </section>
  );
}
